import React from 'react';
import { GlobalProvider } from './context/GlobalProvider';
import AppRoutes from './routes';

function App() {
  return (
    <GlobalProvider>
      <AppRoutes />
    </GlobalProvider>
  );
}

export default App; 